import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import * as lookup from "../../../static/lookup.json"
import Creatable from "react-select/creatable"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from "../context/journeyContext"
import { ErrorContext } from "../context/errorContext"
import { getAllInputQuotations } from "../../services/apiservice"
import { getAge } from "../services/helperFunctions"
import { insWords, lineCapital, formatLookupLabel } from "../../shared/functions"
import {
  findCurrentJourneyCode,
  getKeyFromValueLookup,
  getValueFromLookup,
  getLastPageAndLastSection,
  getValueFromJourney,
  isEquitasChannel
} from "../services/helperFunctions"

const wordsField = ["CPCustomizePlanSumAssured", "sumAssured"]

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 14px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    & div.css-1pahdxg-control {
      background: ${props =>
        props.channel === "A"
          ? "#ededed"
          : "#fff"} !important;
      background: var(--lumiq-bg) !important;
      &:after {
        content: attr(data-words);
        position: absolute;
        right: 3rem;
      }
    }
    margin-top: -17px;
    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 1rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue {
      color: inherit;
    }

    & div.css-yk16xz-control {
      background: ${props =>
        props.channel === "A"
          ? "#ededed"
          : "#fff"};
      background: var(--lumiq-bg);
      position: relative;

      &:after {
        content: attr(data-words);
        position: absolute;
        right: 3rem;
        text-align: end;
        bottom: 8px !important;
      }

      .css-1hb7zxy-IndicatorsContainer > div {
        padding: 0 !important;
      }
    }
    .css-1gtu0rj-indicatorContainer {
      padding: 0 !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props =>
        props.channel === "A"
          ? "#ededed"
          : "#fff"};
      background: var(--lumiq-bg);
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 2px;
    color: #505050;
    font-size: 14px;
    background: ${props =>
      props.channel === "A"
        ? "#ededed"
        : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

export default function ComponentTextCreatableSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [errorState, setErrorState, fieldRefs , scrollToFirstError, scrollFieldToTop] = useContext(ErrorContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [
    optionsForPremiumPaymentTerm,
    setOptionsForPremiumPaymentTerm,
  ] = useState(props.options)
  const [
    optionsForCIPremiumPaymentTerm,
    setOptionsForCIPremiumPaymentTerm
  ] = useState(props.options)

  const [
    optionsForCCBPremiumPaymentTerm,
    setOptionsForCCBPremiumPaymentTerm
  ] = useState(props.options)

  const removeCreate = val => {
    // let s1 = document.querySelector('.css-26l3qy-menu')
    // let s = document.querySelector('.css-4ljt47-MenuList')
    // let arr = options.filter(el=>![undefined,null].includes(el.label))
    // let el  =arr.find(el=>el.label.includes(val))

    // if(!el){
    //   s1.classList?.add('hide-creatable')
    // }else if(el || !val){
    //   s1.classList?.remove('hide-creatable')

    // }

    return val
  }

  const validate = target => {
    if (props.data.required) {
      // required field validation
      if (
        sectionState.sectionData[props.data.formControlKey] === "" ||
        !sectionState.sectionData[props.data.formControlKey]
      ) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]:props.data.requiredError
            ? (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            )): `Error Code Not Found in Strapi`,
          }
        })
      } else {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: "",
          }
        })
      }
      if (target.value) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: "",
          }
        })
      }
    }
    return
  }

  useEffect(() => {
    validate({
      value: sectionState.sectionData[props.data.formControlKey] ?? "",
    })
    setWordsColumn(sectionState.sectionData[props.data.formControlKey])
  }, [sectionState.sectionData[props.data.formControlKey]])

  //To select value to india for as country code
  useEffect(() => {
    if (!sectionState.sectionData[props.data.formControlKey]) {
      if(props?.data?.defaultValue){ // remove this condition && props.sectionId === "CPPersonalDetailsSection"  === "contactCountryCode"
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: props.data.defaultValue
            },
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.data.defaultValue,
          }
        })
      }
      if (props.sectionId === "CPPersonalDetailsSection") {
        if (props.data.formControlKey === "sumAssured") {
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "10000000",
              },
            }
          })
        }
      }
      if (props.data.formControlKey === "policyTerm") {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: "20",
            },
          }
        })
      }
      // setConditionState(prev => {
      //   return {
      //     ...prev,
      //     [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "IN",
      //   }
      // })
    }
  }, [props.sectionId])

  useEffect(() => {
    if (sectionState.sectionData["CPCustomizePlanPolicyTerm"] && props.data.formControlKey === "CPCustomizePlanPremiumPaymentTerm") {
      autoFill(
        "CPCustomizePlanSection",
        "CPCustomizePlanPremiumPaymentTerm",
        "CPCustomizePlanPolicyTerm"
      )
    } 
    else if (
      sectionState.sectionData["iSelect360CPCustomizePlanPolicyTerm"] && props.data.formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm"
    ) {
      autoFill(
        "iSelect360CPCustomizePlanSection",
        "iSelect360CPCustomizePlanPremiumPaymentTerm",
        "iSelect360CPCustomizePlanPolicyTerm"
      )
    }
    else if (
      sectionState.sectionData["iS360CPCustomizePlanPolicyTermCI1"] && props.data.formControlKey === "iS360CPCustomizePlanPremiumPaymentTermCI1"
    ) {
      autoFillCI(
        "iSelect360CPOptionalInBuilt",
        "iS360CPCustomizePlanPremiumPaymentTermCI1",
        "iS360CPCustomizePlanPolicyTermCI1"
      )
    }
    else if (
      sectionState.sectionData["iS360CPCustomizePlanPolicyTermCI2"] && props.data.formControlKey === "iS360CPCustomizePlanPremiumPaymentTermCI2"
    ) {
      autoFillCI(
        "iSelect360CPOptionalInBuilt",
        "iS360CPCustomizePlanPremiumPaymentTermCI2",
        "iS360CPCustomizePlanPolicyTermCI2"
      )
    }
    else if ( 
      sectionState.sectionData["iS360CPSpouseCustomizePlanPolicyTermCI1"] && props.data.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCI1"
    ) {
      autoFillCI(
        "iSelect360CPSpouseCoverDetails",
        "iS360CPSpouseCustomizePlanPremiumPaymentTermCI1",
        "iS360CPSpouseCustomizePlanPolicyTermCI1"
      )
    }
    else if (
      sectionState.sectionData["iS360CPSpouseCustomizePlanPolicyTermCI2"] && props.data.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCI2"
    ) {
      autoFillCI(
        "iSelect360CPSpouseCoverDetails",
        "iS360CPSpouseCustomizePlanPremiumPaymentTermCI2",
        "iS360CPSpouseCustomizePlanPolicyTermCI2"
      )
    }
    else if(sectionState.sectionData["iS360CPCustomizePlanPolicyTermCCB"] && props.data.formControlKey === "iS360CPCustomizePlanPremiumPaymentTermCCB"){
      autoFillCCB(
        "iSelect360CPOptionalInBuilt",
        "iS360CPCustomizePlanPremiumPaymentTermCCB",
        "iS360CPCustomizePlanPolicyTermCCB"
      )
    }else if(sectionState.sectionData["iS360CPSpouseCustomizePlanPolicyTermCCB"] && props.data.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"){
      autoFillCCB(
        "iSelect360CPSpouseCoverDetails",
        "iS360CPSpouseCustomizePlanPremiumPaymentTermCCB",
        "iS360CPSpouseCustomizePlanPolicyTermCCB"
      )
    }

  }, [
    sectionState.sectionData["CPCustomizePlanPolicyTerm"],
    sectionState.sectionData["iSelect360CPCustomizePlanPolicyTerm"],
    sectionState.sectionData["iS360CPCustomizePlanPolicyTermCI1"],
    journeyState.optionValues,                                        //To change PPT keys
    sectionState.sectionData["CPCustomizePlanQuestionOne"],           //To change PPT keys
    sectionState.sectionData["iSelect360CPCustomizePlanQuestionOne"], //To change PPT keys
    sectionState.sectionData["iS360CPCustomizePlanPolicyTermCI2"],
    sectionState.sectionData["iS360CPSpouseCustomizePlanPolicyTermCI1"],
    sectionState.sectionData["iS360CPSpouseCustomizePlanPolicyTermCI2"],
    sectionState.sectionData["iS360CPCustomizePlanPolicyTermCCB"],
    sectionState.sectionData["iS360CPSpouseCustomizePlanPolicyTermCCB"],
  ])

  useEffect(() => {
    if ((props.sectionId === "CPCustomizePlanSection" && props.data.formControlKey === "CPCustomizePlanPremiumPaymentTerm") || (props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm")){
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "iSelectJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CPCustomizePlanSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CPCustomizePlan")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CPCustomizePlanPaymentFrequency")
      } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPCustomizePlanSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPCustomizePlan")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        if(!(sectionState.sectionData["CPCustomizePlanPaymentFrequency"] === "SG" || sectionState.sectionData["iSelect360CPCustomizePlanPaymentFrequency"] === "SG" )){
          if (props.journeyIdFromStrapi === "iSelectJourney") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CPCustomizePlanPaymentFrequency"]: "SG",
                }
              })
            })
          } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["iSelect360CPCustomizePlanPaymentFrequency"]: "SG",
                }
              })
            })
          }
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          // console.log(temp, "iimp")
  
          // setJourneyState(prev => {
          //   return ({
          //     ...prev,
          //     journeySteps: temp
          //   })
          // })
          props.saveApplicationAndCallBi("iSelect360CPCustomizePlanPaymentFrequency", "SG")
        }
      } else {
        if(sectionState.sectionData["CPCustomizePlanPaymentFrequency"] === "SG" || sectionState.sectionData["iSelect360CPCustomizePlanPaymentFrequency"] === "SG"){
          if (props.journeyIdFromStrapi === "iSelectJourney") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CPCustomizePlanPaymentFrequency"]: "01",
                }
              })
            })
          } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["iSelect360CPCustomizePlanPaymentFrequency"]: "01",
                }
              })
            })
          }
          props.saveApplicationAndCallBi("iSelect360CPCustomizePlanPaymentFrequency", "01")
        }
        
        let temp = journeyState.journeySteps
        console.log(temp, "dfg")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        console.log(temp, "iimp")
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
  }, [sectionState.sectionData[props.data.formControlKey]])
  const autoFill = (sectionID, formContrlKey, policyTermKey) => {
    if (
      props.sectionId === sectionID &&
      props.data.formControlKey === formContrlKey
    ) {
      if (sectionState.sectionData[policyTermKey]) {
        let conditionStatePlanOptionKey
        if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
          conditionStatePlanOptionKey = "calculatePremiumPage.CPCustomizePlanSection.CPCustomizePlanQuestionOne"
        }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
          conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
        }
        // else if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney"){
        //   conditionStatePlanOptionKey = "PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingInvestmentDetails.planOption"
        // }
        else{
          return 
        }
        if (Object.keys(journeyState.optionValues).length) {
          let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData[policyTermKey]]
          console.log(options, "OptionsBeforeA60")
          if (options) {
            let valueAtKey = options["60-@LI_ENTRY_AGE"] || options["60-@li_entry_age"]
            if (valueAtKey) {
              delete options["60-@LI_ENTRY_AGE"]
              delete options["60-@li_entry_age"]
              options["A60"] = "Upto age 60 YEARS"
            }
            setOptionsForPremiumPaymentTerm(options)
            if (props.saveApplicationAndCallBi) {
              if (!props.firstPassForPremiumPaymentBicall) {
                if (props.journeyIdFromStrapi === "iSelectJourney") {
                  props.saveApplicationAndCallBi(
                    "CPCustomizePlanPremiumPaymentTerm",
                    sectionState.sectionData[
                    "CPCustomizePlanPremiumPaymentTerm"
                    ]
                  )
                } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
                  props.saveApplicationAndCallBi(
                    "iSelect360CPCustomizePlanPremiumPaymentTerm",
                    sectionState.sectionData[
                    "iSelect360CPCustomizePlanPremiumPaymentTerm"
                    ]
                  )
                }
              } else {
                props.setFirstPassForPremiumPaymentBicall(false)
              }
            }
          }
        }
        
      }
    }
  }

  const autoFillCI = (sectionID, formContrlKey, policyTermKey) => {
    if (
      props.sectionId === sectionID &&
      props.data.formControlKey === formContrlKey
    ) {
      
      if (sectionState.sectionData[policyTermKey]) {
        let reqPT
        reqPT = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPremiumPaymentTerm"]
        if(reqPT > sectionState.sectionData[policyTermKey]){
          reqPT = sectionState.sectionData[policyTermKey]
        }

        let conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"

        if (Object.keys(journeyState.optionValues).length) {
          let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[reqPT]
          console.log(options, "OptionsBeforeA60")
          if (options) {
            let valueAtKey = options["60-@LI_ENTRY_AGE"] || options["60-@li_entry_age"]
            if (valueAtKey) {
              delete options["60-@LI_ENTRY_AGE"]
              delete options["60-@li_entry_age"]
              options["A60"] = "Upto age 60 YEARS"
            }
            setOptionsForCIPremiumPaymentTerm(options)
          }
        }
      }
    }
  }

  const autoFillCCB = (sectionID, formContrlKey, policyTermKey) => {
    if (
      props.sectionId === sectionID &&
      props.data.formControlKey === formContrlKey
    ) {
      
      if (sectionState.sectionData[policyTermKey]) {
        let reqPT = sectionState.sectionData[policyTermKey]
        let conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"

        if (Object.keys(journeyState.optionValues).length) {
          let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[reqPT]
          console.log(options, "OptionsBeforeA60")
          if (options) {
            let valueAtKey = options["60-@LI_ENTRY_AGE"] || options["60-@li_entry_age"]
            if (valueAtKey) {
              delete options["60-@LI_ENTRY_AGE"]
              delete options["60-@li_entry_age"]
              options["A60"] = "Upto age 60 YEARS"
            }
            setOptionsForCCBPremiumPaymentTerm(options)
          }
        }
      }
    }
  }

  const handleChange = target => {
    let regex = new RegExp(/^\d+$/)
    let tempForPPT = target.value
    if (regex.test(target.value.replace(/,/g, ""))) {
      let temp = target.value.split(",")
      target.value = temp.join("")
      // target.value = target.value.replaceAll(",", "")
    } else if (target.value == "") {
      target.value = ""
    } else {
      target.value = ""
    }
    if (tempForPPT == "A60") {
      target.value = "A60"
    }

    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }

    // setWordsColumn(target.value)

    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    // console.log(conditionState, "dhdhdj")

    validate(target)
    if (
      props.data.formControlKey === "sumAssured" &&
      (props.sectionId === "CPSpouseCoverDetails" ||
        props.sectionId === "CPPersonalDetailsSection")
    ) {
      let isNotMultipleOfLakh = target.value % 100000
      if (isNotMultipleOfLakh) {
        setErrorState(prev => {
          return {
            ...prev,
            ["sumAssuredMultipleOfLakh"]:
              "Sum Assured Must Be A Multiple of 1 Lakh",
          }
        })
        setShowLocalError(true)
        return
      } else {
        setErrorState(prev => {
          return {
            ...prev,
            ["sumAssuredMultipleOfLakh"]: "",
          }
        })
        if (props.saveApplicationAndCallBi) {
          props.saveApplicationAndCallBi(
            props.data.formControlKey,
            target.value
          )
        }
      }
    } else if((props.sectionId === "CPCustomizePlanSection" && props.data.formControlKey === "CPCustomizePlanPremiumPaymentTerm") || 
      (props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm")
    ){
      if(target.value !== "1" &&
       ((props.journeyIdFromStrapi === "ISelect360Journey" && sectionState.sectionData["iSelect360CPCustomizePlanPaymentFrequency"] !== "SG")
       || (props.journeyIdFromStrapi === "iSelectJourney" && sectionState.sectionData["CPCustomizePlanPaymentFrequency"] !== "SG"))){
        props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
      }
    }else {
      if (props.saveApplicationAndCallBi) {
        props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
      }
    }
    // console.log(sectionState, "section state")
  }
  // function checkSumAssuredAndCallBi(target){
  //   if(props.data.formControlKey === "sumAssured" && props.sectionId === "CPSpouseCoverDetails"){
  //     let isNotMultipleOfLakh = target.value%100000
  //     console.log("kjfkjfjkfd", isNotMultipleOfLakh, target.value)
  //     if(isNotMultipleOfLakh){
  //       console.log("errorState", "kjfkjfjkfd")
  //       setErrorState(prev => {
  //         return {
  //           ...prev,
  //           [props.data.formControlKey]: "Sum Assured Must Be A Multiple of 1 Lakh",
  //         }
  //       })
  //       setShowLocalError(true)
  //       return
  //     }else{
  //       setErrorState(prev => {
  //         return {
  //           ...prev,
  //           [props.data.formControlKey]: "",
  //         }
  //       })
  //       if(props.saveApplicationAndCallBi){
  //         props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
  //       }

  //     }
  //   }else{
  //     if(props.saveApplicationAndCallBi){
  //       props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
  //     }
  //   }
  // }

  function setWordsColumn(val) {
    if (!wordsField.includes(props.data.formControlKey)) {
      return
    }
    let x = document.querySelector(
      `.${props.data.formControlKey} .css-1pahdxg-control`
    )
    let y = document.querySelector(
      `.${props.data.formControlKey} .css-yk16xz-control`
    )
    let words = insWords(val || "0")
    x?.setAttribute("data-words", words)
    y?.setAttribute("data-words", words)
  }

  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }
  let options
  if (
    props.pageId === "calculatePremiumPage" &&
    props.sectionId === "CPCustomizePlanSection" &&
    props.data.formControlKey === "CPCustomizePlanPremiumPaymentTerm"
  ) {
    options = optionsForPremiumPaymentTerm
    // console.log(optionsForPremiumPaymentTerm, options, "dsffdjfjfj7")
  } else if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPCustomizePlanSection" &&
    props.data.formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm"
  ) {
    console.log("options ", optionsForPremiumPaymentTerm)
    options = optionsForPremiumPaymentTerm
  } else if(props.pageId === "calculatePremiumPage" && props.sectionId === "CPPersonalDetailsSection" && props.data.formControlKey === "policyTerm"){
    options = journeyState.policyTermLookup
  } else if(props.pageId === "calculatePremiumPage" && props.sectionId === "CPCustomizePlanSection" && props.data.formControlKey === "CPCustomizePlanPolicyTerm"){
    options = journeyState.policyTermLookup
  } else if(props.pageId === "PageISelect360CalculatePremium" && props.sectionId === "CPPersonalDetailsSection" && props.data.formControlKey === "policyTerm"){
    if(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"]){
      if(getAge(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"]) < 35){
        options = journeyState.policyTermLookupUpto35
      }else{
        options = journeyState.policyTermLookup
      }
    }else{
      options = journeyState.policyTermLookup
    }
  } else if(props.pageId === "PageISelect360CalculatePremium" && props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPolicyTerm"){
    if(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"]){
      if(getAge(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"]) < 35){
        options = journeyState.policyTermLookupUpto35
      }else{
        options = journeyState.policyTermLookup
      }
    }else{
      options = journeyState.policyTermLookup
    }
  }else if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPOptionalInBuilt" &&
    props.data.formControlKey === "iS360CPCustomizePlanPremiumPaymentTermCCB"
  ) {
    options = optionsForCCBPremiumPaymentTerm
  }else if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPSpouseCoverDetails" &&
    props.data.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"
  ) {
    options = optionsForCCBPremiumPaymentTerm
  }else if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPOptionalInBuilt" &&
    props.data.formControlKey === "iS360CPCustomizePlanPremiumPaymentTermCI1"
  ) {
    
    options = optionsForCIPremiumPaymentTerm
  }
  else if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPOptionalInBuilt" &&
    props.data.formControlKey === "iS360CPCustomizePlanPremiumPaymentTermCI2"
  ) {
    
    options = optionsForCIPremiumPaymentTerm
  }
  else if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPSpouseCoverDetails" &&
    props.data.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCI1"
  ) {
    
    options = optionsForCIPremiumPaymentTerm
  }
  else if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPSpouseCoverDetails" &&
    props.data.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCI2"
  ) {
    
    options = optionsForCIPremiumPaymentTerm
  }
  else {
    options = props.options
  }
  // console.log(options);
  options = Object.entries(options).map(([key, val]) => ({
    value: key,
    label: formatLookupLabel(val),
  }))

  options = options
    .filter(el => ![undefined, null].includes(el.value))
    .find(el =>
      el.value.includes(sectionState.sectionData[props.data.formControlKey])
    )
    ? options
    : [
        ...options,
        {
          value: sectionState.sectionData[props.data.formControlKey],
          label: formatLookupLabel(sectionState.sectionData[props.data.formControlKey]),
        },
      ]

  return (
    <>
      <SelectContainer
        channel={props.channel}
        className={`input-container ${
          props.data.disabled ? "disable-input" : ""
        } ${props.data?.freeze ? "freeze-input" : ""} ${
          props.data.formControlKey
        }`}
      >
        <label htmlFor={props.data.label} className="input-label">
        {(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
        {isEquitasChannel(props.channel) && props.data.required && <span className="equitas-required-marker"> *</span>}
        </label>
        <Creatable
          options={options}
          name={+Date.now()}
          onChange={handleChange}
          onFocus={() => scrollFieldToTop(props.data.formControlKey)}
          id="InputSelect"
          classNamePrefix="custom-select option"
          tabIndex={props.data.disabled || props.data?.freeze ? -1 : 0}
          placeholder={(getValueFromJourney(
            journeyState.lookup.placeholder,
            props.data.placeholder
          )) || props.data.placeholder}
          value={
            sectionState.sectionData[props.data.formControlKey]
              ? getKeyByValue(
                  options,
                  sectionState.sectionData[props.data.formControlKey]
                )
              : ""
          }
          formatCreateLabel={removeCreate}
          // onBlur={e => validate(e.target)}
        />
        <span className="input-error2">
          {(props.showError || showLocalError) &&
            errorState[props.data.formControlKey]}
          {(props.showError || showLocalError) &&
            props.data.formControlKey === "sumAssured" &&
            (props.sectionId === "CPSpouseCoverDetails" ||
              props.sectionId === "CPPersonalDetailsSection") &&
            errorState["sumAssuredMultipleOfLakh"]}
        </span>
      </SelectContainer>
    </>
  )
}
